module.exports = __webpack_public_path__ + "img/13ne.acf637c7.svg";